import React from 'react';
import cs from 'classnames';
import { ReactBootstrapModal } from 'shared/components/ReactModal';
import { useTermsAndConditionsQuery } from '../generated.graphql';


interface Props {
  portalSlug: string;
  className?: string;
  children?: React.ReactChild;
}


export const TermsAndConditionsModalContent = (props: Props) => {
  const [result,] = useTermsAndConditionsQuery({variables: {portalSlug: props.portalSlug}, requestPolicy: "cache-first"})
  return (
    <div 
      className="py-3"
      dangerouslySetInnerHTML={{
        __html: result.data?.portal?.policies.terms?.content.replace(/href/g, "target='_blank' href") || "<div>Loading...</div>"
      }}
    />
  )
}


interface TermsAndConditionsModalProps {
  portalSlug: string
  isOpen: boolean
  onClose: () => void
}

export const TermsAndConditionsModal = (props: TermsAndConditionsModalProps) => (
  <ReactBootstrapModal
    title="Your Rental Terms"
    isOpen={props.isOpen}
    onRequestClose={() => props.onClose()}
  >
    <TermsAndConditionsModalContent portalSlug={props.portalSlug} />
  </ReactBootstrapModal>
)


export const TermsAndConditionsModalButton = (props: Props) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <>
       <button type="button" className={cs(props.className ?? "btn btn-link px-0 border-0")} onClick={() => setIsOpen(true)}>
        {props.children ?? 'Read the full terms and conditions'}
      </button>
      <TermsAndConditionsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        portalSlug={props.portalSlug}
      />
    </>
  )
}

